// app/localization/index.js
import { createI18n } from 'vue-i18n';
import { i18nManager } from '@ozdao/martyrs/modules/core/client';

import translations from './translations.js';
import overrides from './overrides.js';
import extensions from './extensions.js';

const supportedLocales = {
  en: "🇬🇧 EN",
  ru: "🇷🇺 RU"
};

// Настройка переводов приложения
export function getLocales() {
  // Языки отдаём менеджеру: по ним LocaleSwitcher строит список, а роут-гард
  // языка решает, какой префикс валидный. Английский — язык по умолчанию, он
  // живёт без префикса, русский — на /ru.
  i18nManager.setSupportedLocales(supportedLocales);
  i18nManager.setDefaultLocale('en');

  // Регистрируем локальные переводы
  if (translations) {
    Object.entries(translations).forEach(([module, locales]) => {
      i18nManager.register(module, locales);
    });
  }

  // Применяем расширения если есть
  if (extensions) {
    Object.entries(extensions).forEach(([module, locales]) => {
      i18nManager.extend(module, locales);
    });
  }

  // Применяем переопределения если есть
  if (overrides) {
    Object.entries(overrides).forEach(([module, locales]) => {
      i18nManager.override(module, locales);
    });
  }

  // Получаем финальные переводы
  const messages = i18nManager.getAllMessages();
  
  // Создаем экземпляр i18n
  const i18n = createI18n({
    legacy: false,
    locale: 'en',
    fallbackLocale: 'en',
    messages,
    globalInjection: true,
    availableLocales: Object.keys(supportedLocales),
  });

  // ОБЯЗАТЕЛЬНО! Без этого модули не смогут добавлять переводы динамически
  i18nManager.setI18nInstance(i18n);

  return i18n;
}

// Legacy export for compatibility
export default getLocales();
